const autoNgTemplateLoaderTemplate1 = require('./editCustomTemplateView.html');

import EditCustomTemplateViewController from './editCustomTemplateViewController.js';

angular.module('portainer.app').component('editCustomTemplateView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: EditCustomTemplateViewController,
});
